import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';


class ModalConfirm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    headerNode: PropTypes.node,
    content: PropTypes.node,
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.open !== nextProps.open) {
      return true;
    }
    return false;
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        size="small"
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={this.props.headerNode || `${t('Confirm', { ns: TRANSLATION_FILES.translation })}?`} />
        <Modal.Content>
          <Modal.Description>
            {
              this.props.content || <p>{t('Are you sure to continue')}?</p>
            }
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content={t('No', { ns: TRANSLATION_FILES.constants })} inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="checkmark" content={t('Yes', { ns: TRANSLATION_FILES.constants })} inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(ModalConfirm);



// WEBPACK FOOTER //
// ./src/containers/modals/ModalConfirm.jsx